export default {
    SET_CATALOG(state, catalog) {
        state.catalog = catalog
        state.catalogFetchedAt = Date.now()
    },
    SET_CONFIG(state, config) {
        state.config = config
    },
    SET_DASHBOARD(state, dashboard) {
        state.dashboard = dashboard
        state.dashboardFetchedAt = Date.now()
    },
    SET_PERIOD(state, period) {
        state.period = period
    },
    SET_LOADING(state, loading) {
        state.loading = loading
    },
    SET_SAVING(state, saving) {
        state.saving = saving
    },
    SET_ERROR(state, error) {
        state.error = error
    },
    INVALIDATE_DASHBOARD(state) {
        state.dashboard = null
        state.dashboardFetchedAt = null
    },
    INVALIDATE_CATALOG(state) {
        state.catalog = null
        state.catalogFetchedAt = null
    }
}
